import { KenticoValidatorUtils } from "../kentico/KenticoUtils";

export class FieldVisibilityHelpers {
    static isFormDefinedInConditionButNotEXistsInFormValues(condition : any, formValues: any) {
        return condition.form !== undefined && formValues[condition.form] === undefined;
    }

    static isFormDefinedInConditionButFieldDoesntExistInForm(condition : any, formValues: any) {
        return condition.form !== undefined && formValues[condition.form] !== undefined && 
            formValues[condition.form][condition.fieldName] === undefined;
    }

    static isArrayConditionAndFieldValueDoesntExist(condition : any, formValues: any) {
        return (condition.form !== undefined && formValues[condition.form] !== undefined && 
            condition.value instanceof Array &&
            (typeof formValues[condition.form][condition.fieldName] == "string") && 
            condition.value.indexOf(formValues[condition.form][condition.fieldName]) < 0);
    }

    static isFieldValueNotEqualToConditionValue(condition : any, formValues: any) {
        return condition.form !== undefined && formValues[condition.form] !== undefined && 
            !(condition.value instanceof Array) &&
            (typeof formValues[condition.form][condition.fieldName] == "string") && 
            condition.value != formValues[condition.form][condition.fieldName];
    }

    static isFieldValueEmptyAndNotEmptyCondition(condition : any, formikBag: any) {    
        return condition.form === undefined && 
            (formikBag.values[condition.fieldName] === undefined || 
             (condition.value == "__NOTEMPTY__" &&
              formikBag.values[condition.fieldName] == "")
            );
    }

    static isFieldObjectValueNotEqualToConditionValue(condition : any, formValues: any) {
        return condition.form !== undefined && formValues[condition.form] !== undefined && 
            formValues[condition.form][condition.fieldName] instanceof Object && 
            typeof condition.value == "string" &&
            condition.value != formValues[condition.form][condition.fieldName].value;
    }

    static isFormUndefinedOrCurrentFieldValueUndefinedOrEmpty(condition : any, formikBag: any) {
        return condition.form === undefined && 
            (formikBag.values[condition.fieldName] === undefined || 
            formikBag.values[condition.fieldName] == "");
    }

    static isArrayCondition(condition : any) {
        return condition.form === undefined && condition.value instanceof Array;
    }

    static isCurrentFieldValueNotInArrayCondition(condition : any, formikBag : any) {
        return (condition.value.indexOf(formikBag.values[condition.fieldName]) < 0);
    }

    static isCurrentFieldObjectValueNotEqualToConditionValue(condition : any, formikBag : any) {
        return condition.form === undefined && 
            formikBag.values[condition.fieldName] instanceof Object && 
            formikBag.values[condition.fieldName].value !== undefined && 
            typeof condition.value == "string" &&
            condition.value != "__NOTEMPTY__" &&
            formikBag.values[condition.fieldName].value != condition.value;
    }

    static isCurrentFieldValueOfTypeStringWithSubstringCondition(condition : any, formikBag : any) {
        return condition.form === undefined && 
            typeof formikBag.values[condition.fieldName] == "string" && 
            typeof condition.value == "string" &&
            typeof condition.substring !== "undefined";
    }
    
    static isCurrentFieldValueNotEqualToConditionValue(condition : any, formikBag : any) {
        return condition.form === undefined && 
            typeof formikBag.values[condition.fieldName] == "string" &&
            condition.value != "__NOTEMPTY__" && 
            typeof condition.value == "string" &&
            formikBag.values[condition.fieldName] != condition.value;
    }

    static isNotEQConditionalConditionAndValuesAreEqual(condition : any, subValue : string) {
        return (condition.condition == "NOTEQ" &&
            condition.value != "__NOTEMPTY__" &&
            typeof condition.value == "string" && 
            subValue.toLowerCase() == condition.value.toLowerCase());
    }
    
    static isEQConditionAndValuesAreNotEqual(condition : any, subValue : string) {
        return condition.condition == "EQ" &&
            condition.value != "__NOTEMPTY__" &&
            typeof condition.value == "string" &&
            subValue.toLowerCase() != condition.value.toLowerCase();
    }

    static checkKenticoVisibilityRule(condition: any, formikBag : any, formFieldDefinition : any, fieldsMapper : any) {

        let value = "";

        if (formikBag !== undefined && formikBag.values !== undefined && formikBag.values[formFieldDefinition.name] !== undefined) {
            if (formikBag.values[formFieldDefinition.name] !== undefined &&
                formikBag.values[formFieldDefinition.name] !== null && 
                formikBag.values[formFieldDefinition.name].value !== undefined) {
                value = formikBag.values[formFieldDefinition.name].value || "";
            } else {
                value = formikBag.values[formFieldDefinition.name] || "";
            }
        }    
        if (value === undefined) {
            value == "";
        }
        return condition.kenticoVisibilityFunction(fieldsMapper, value, KenticoValidatorUtils);        
    }
}
